<template>
  <div
    :class="{ loader: true, fadeout: !isLoading }"
    class="justify-content-center d-flex flex-wrap align-items-center flex-column"
  >
    <b-img
      alt="Vue logo"
      :src="require('@/assets/loading.gif')"
      class="align-self-center img-loader"
    ></b-img>

    <div class="loading-text">Loading<span class="loading-dots">...</span></div>
  </div>
</template>

<script>
export default {
  name: "LoadingScreen",
  props: ["isLoading"],
};
</script>

<style>
.loader {
  min-height: 100vh;

  /* background-color: #0b40a2; */

  background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.75) 0%,
      rgba(0, 0, 0, 0.45) 25%,
      rgba(0, 0, 0, 0.15) 50%,
      rgba(0, 0, 0, 0) 75%
    ),
    url("../assets/login-logo-mobile.png");

  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  /* background-color: #0b40a2;
  bottom: 0;
  color: white;
  display: block;
  font-size: 32px;
  left: 0;
  overflow: hidden;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 2000; */
}

.img-load {
  width: 40%;
  height: 40%;
}

.img-loader {
  width: 50px;
}

.loading-text {
  margin-top: 12px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
}

.loading-dots {
  display: inline-block;
  width: 1.2em;
  text-align: left;
  animation: loadingDots 1.4s infinite steps(3, end);
}

@keyframes loadingDots {
  0% {
    opacity: 0.2;
    content: "";
  }
  33% {
    opacity: 1;
    content: ".";
  }
  66% {
    opacity: 1;
    content: "..";
  }
  100% {
    opacity: 1;
    content: "...";
  }
}

.fadeout {
  animation: fadeout 0.3s forwards;
}

@keyframes fadeout {
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>
